// extracted by mini-css-extract-plugin
export var container = "dropdown-module--container--LLDf4";
export var left = "dropdown-module--left--5UUD7";
export var open = "dropdown-module--open--f4wFh";